export default __webpack_public_path__ + "static/media/hht1_ep3_minisitcom_03.9f006441.png";